export default {
  data () {
    return {
      inPageNavActive: null
    }
  },
  methods: {
    updateInPageNav (target, direction) {
      if (direction === this.$scrollDirection().y) {
        this.inPageNavActive = target
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/updateInPageNav.js